export default __webpack_public_path__ + "static/front-f16d3ad03bb25484b406070fa77c0cb0.png";